// Load recently viewed products when this section loads
document.addEventListener('DOMContentLoaded', function() {
    if (window.loadRecentlyViewedProducts) {
        window.loadRecentlyViewedProducts();
    }
});
